import { useCallback } from "react";

import { ModalsContainer } from "../../components/ModalsContainer";
import { RouteEditorModalState } from "../../RouteEditor.types";

export type RouteEditorCreateModalsBlockProps = {
    modalState: RouteEditorModalState;
    onSetModalState: (state: RouteEditorModalState) => void;
    onExitMultiSelectMode: () => void;
};

export const RouteEditorCreateModalsBlock = ({
    modalState,
    onSetModalState,
    onExitMultiSelectMode,
}: RouteEditorCreateModalsBlockProps) => {
    const handleClose = useCallback(() => {
        onSetModalState(null);
    }, [onSetModalState]);

    const handleAfterConfirm = useCallback(async () => {
        onExitMultiSelectMode();
    }, [onExitMultiSelectMode]);

    return (
        <ModalsContainer
            onClose={handleClose}
            modalState={modalState}
            onAfterConfirm={handleAfterConfirm}
        />
    );
};
